let capturedElements = [];
let toggleTips = [];

class ToggleTip {
    constructor(element) {
        this.controller = element;
        this.content = this.getContent();

        this.buildToggleTip();
    }

    buildToggleTip = () => {
        this.controller.classList.add('jwc-toggletip');
        this.controller.setAttribute('data-state', 'closed');
        
        // liveRegion is for accessibility
        this.liveRegion = document.createElement('span');
        this.liveRegion.classList.add('jwc-toggletip-container');
        this.liveRegion.setAttribute('role', 'status');
        
        this.controller.appendChild(this.liveRegion);
        
        this.controller.addEventListener('click', this.clickHandler);
        this.controller.addEventListener('blur', (e) => {
                this.clearContent();
        });

        this.controller.addEventListener('keydown', (e) => {
            if ((e.keyCode || e.which) === 27) {
                this.clearContent();
            }
        });
    }

    getContent = () => {
        const contentContainer = this.controller.querySelector('[data-toggletip-text]');
        const content = contentContainer !== null ? contentContainer.innerHTML : this.controller.innerHTML;

        if (contentContainer) contentContainer.parentElement.removeChild(contentContainer);

        return content;
    }

    clickHandler = (e) => {
        e.preventDefault();

        this.addContent();

        document.addEventListener('click', this.bodyClickHandler, { once: true });
    }

    bodyClickHandler = (e) => {
        if (this.controller !== e.target) {
            this.clearContent();
        }
    }

    addContent = () => {
        window.setTimeout(() => {
            this.liveRegion.innerHTML = this.content;
            this.controller.setAttribute('data-state', 'open');
        })
    }

    clearContent = (e) => {
        this.liveRegion.innerHTML = '';
        this.controller.setAttribute('data-state', 'closed');
    }
}

export const addToggleTip = element => {
    capturedElements.push(element);
    toggleTips.push(new ToggleTip(element));
};

export default init = (target = document) => {
    const targetElements = [...target.querySelectorAll('[data-toggletip]')];
    const dedupedTargetElements = targetElements.filter(targetElement => !capturedElements.find(capturedElement => targetElement === capturedElement));

    if (dedupedTargetElements.length === 0) return;

    dedupedTargetElements.forEach(element => {
        capturedElements.push(element);
        toggleTips.push(new ToggleTip(element));
    });
}